// src/hooks/firestore/utils/subscriptions.ts
import { debugLog } from './debug';

// Track active subscriptions to prevent duplicates
export const activeSubscriptions = new Map<string, () => void>();

// Get a unique key for a subscription based on path and constraints
export const getSubscriptionKey = (collectionPath: string, constraintsJson: string) => {
  return `${collectionPath}|${constraintsJson}`;
};

// Clean up existing subscription before creating a new one
export const cleanupSubscription = (subscriptionKey: string) => {
  const unsubscribe = activeSubscriptions.get(subscriptionKey);
  if (unsubscribe) {
    unsubscribe();
    activeSubscriptions.delete(subscriptionKey);
    debugLog(`Cleaned up previous subscription: ${subscriptionKey}`);
  }
}; 